import React, { useState,useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SortIcon from "@material-ui/icons/Sort";
import SearchIcon from "@material-ui/icons/Search";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { useData } from "../../context/DataContext";
import { db } from "../../config/Firebase";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: `100%`,
    margin: `0 10px`,
    borderRadius: 30
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  iconButton: {
    "&:hover": {
      background: `transparent`,
      cursor: `default`,
    },
  },
  icon:{
    backgroundColor: theme.palette.primary.main,
    color: `#fff`,
    padding: 10,
    "&:hover":{
      backgroundColor: theme.palette.primary.main,
    }
  },
  label:{
    padding: 10,
    width: `100%`,
    margin: `4px 0px`,
    boxShadow: `0 0 3rem rgba(0,0,0,0.06)`
  },
  popup:{
    width: 250
  }
}));

const options = [
  {name: "highest $",type: "desc",field: "price"},
  {name: "lowest $",type: "asc",field: "price"},
  {name: "Latest",type: "desc",field: "time"},
]

function ConfirmationDialogRaw({ onClose, value: valueProp, open, ...other }) {
  const [value, setValue] = useState(valueProp);
  const radioGroupRef = useRef();
  const classes = useStyles();
  const { tags } = useData();
  class Tags {
    constructor(tag={}){
      this[0] = {
        ...tag,
        type: tag.type.name === "number" ? "desc" : "asc",
        Icon: ArrowUpwardIcon,
        field: `tags.${tag.name}`
      };
      this[1] = {
        ...tag,
        type: tag.type.name === "number" ? "asc" : "desc",
        Icon: ArrowDownwardIcon,
        field: `tags.${tag.name}`
      }
    }
  }
  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(value);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Dialog maxWidth="sm"
      onEntering={handleEntering}
      onClose={handleOk}
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <div className={classes.popup}>
      <DialogTitle id="confirmation-dialog-title">Sorted By</DialogTitle>
      <DialogContent dividers>
        <RadioGroup
          ref={radioGroupRef}
          aria-label="ringtone"
          name="ringtone"
          value={value}
          onChange={handleChange}
        >
          {options.map((option,i) => (
            <div className="d-flex align-items-center">
              <Radio id={`${option.field}::${option.type}`} color="primary" value={`${option.field}::${option.type}`} key={option.name} />
              <label htmlFor={`${option.field}::${option.type}`}> {option.name} </label>
            </div>
          ))}
          {tags.map((el,i)=>new Tags(el,i)).map((option,i) => {
            const opt1 = option[0];
            const opt2 = option[1];
            return <>
              <div className="d-flex align-items-center">
              <Radio id={`${opt1.field}::${opt1.type}`} color="primary" value={`${opt1.field}::${opt1.type}`} key={opt1.name} />
              <label className="text-capitalize" htmlFor={`${opt1.field}::${opt1.type}`}> {opt1.name} <opt1.Icon style={{fontSize: `1rem`}} /> </label>
            </div>
            <div className="d-flex align-items-center">
              <Radio id={`${opt2.field}::${opt2.type}`} color="primary" value={`${opt2.field}::${opt2.type}`} key={opt2.name} />
              <label className="text-capitalize" htmlFor={`${opt2.field}::${opt2.type}`}> {opt2.name} <opt2.Icon style={{fontSize: `1rem`}} /> </label>
            </div>
            </>
})}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary">
          Ok
        </Button>
      </DialogActions>
      </div>
    </Dialog>
  );
}


const SearchBar = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const { setFiltered } = useData()
  const search = useRef();
  const handleClickListItem = () => setOpen(true)
  const handleClose = (newValue) => {
    setOpen(false);
    if (newValue) {
      setValue(newValue);
    }
  };
  useEffect(()=>{
    if(value){
      const [orderBy,order] =value.split("::");
      setFiltered([],false)
      db.collection("persons").orderBy(orderBy,order).onSnapshot(snapShot=>{
        const array = [];
        snapShot.forEach(doc=>{
          const data = doc.data();
          data.id = doc.id;
          array.push(data);
        });
        setFiltered(array,true)
      })
    }
  },[value,setFiltered])
  const onSubmit = (e)=> {
    e.preventDefault();
    setFiltered([],false)
    db.collection("persons").orderBy("name").startAt(search.current.value).endAt(search.current.value+"\uf8ff").onSnapshot(snapShot=>{
      const array = [];
      snapShot.forEach(doc=>{
        const data = doc.data();
        data.id = doc.id;
        array.push(data);
      });
      setFiltered(array,true)
    })
  }
  return (
    <div className="searchbar container-fluid">
      <div className="search_inner pt-4">
        <Paper component="form" onSubmit={onSubmit} className={classes.root+" shadow"}>
        <IconButton onClick={handleClickListItem}>
            <SortIcon />
          </IconButton>
          <InputBase
            className={classes.input}
            inputRef={search}
            placeholder="Search"
            id="my_input"
            required
          />
          <div>
            <IconButton type="submit">
              <SearchIcon />
            </IconButton>
          </div>
        </Paper>
      </div>
      <ConfirmationDialogRaw id="ringtone-menu" keepMounted open={open} onClose={handleClose} />
    </div>
  );
};

export default SearchBar;
